import './index.sass'
import 'react-notifications/lib/notifications.css';
import {NotificationContainer} from "react-notifications";

export default function Notification() {
    return <NotificationContainer/>
}